module.exports = __webpack_public_path__ + "img/success_image.f5c52906.png";